import posthog from "posthog-js";

type InitializeOptions = {
  apiHost?: string;
  personProfiles?: "identified_only" | "always" | "never";
};

export class Posthog {
  static initialize = (apiKey: string, options: InitializeOptions = {}) => {
    const apiHost = options.apiHost ?? "https://us.i.posthog.com";
    const personProfiles = options.personProfiles ?? "identified_only";

    // Safe to call multiple times; posthog guards against duplicate inits
    posthog.init(apiKey, {
      api_host: apiHost,
      person_profiles: personProfiles,
      capture_pageview: true,
      capture_pageleave: true,
    } as any);
  };

  static identify = (userId: string, properties?: Record<string, any>) => {
    posthog.identify(userId, properties);
  };

  static capture = (event: string, properties?: Record<string, any>) => {
    posthog.capture(event, properties);
  };
}
